import { Button, Heading, Modal, Text } from '@afterpaytouch/core'
import { MaskedElement } from '@afterpaytouch/integrations/MaskedElement'
import { ConsumerAddress } from '@afterpaytouch/portal-api'
import { useTranslation } from 'next-i18next'
import React, { FunctionComponent } from 'react'

const I18N_NAMESPACE = ['common', 'account']

interface AddressSuggestionProps {
  original: ConsumerAddress
  suggested: ConsumerAddress
  onAccept: () => void
  onEdit: () => void
  isLoading: boolean
}

const formatAddress = (a: ConsumerAddress): string => {
  return [a.address1, a.address2, a.suburb, a.state, a.postcode].filter(Boolean).join(', ')
}

export const AddressSuggestion: FunctionComponent<AddressSuggestionProps> = ({ original, suggested, onAccept, onEdit, isLoading }) => {
  const { t } = useTranslation(I18N_NAMESPACE)
  const testNameSpace = 'edit-address-modal-suggestion'

  return (
    <>
      <Modal.Header divider>
        <div className='text-center'>
          <Heading testNameSpace={testNameSpace} size='L'>
            {t('account:edit:address:suggestion:header:heading')}
          </Heading>
        </div>
      </Modal.Header>
      <Modal.Content>
        <MaskedElement testNameSpace={`${testNameSpace}-pii`}>
          <div className='space-y-4'>
            <div>
              <Text size='S' bold>
                {t('account:edit:address:suggestion:content:youEntered')}
              </Text>
              <Text size='M'>{formatAddress(original)}</Text>
            </div>
            <div>
              <Text size='S' bold>
                {t('account:edit:address:suggestion:content:didYouMean')}
              </Text>
              <Text size='M'>{formatAddress(suggested)}</Text>
            </div>
          </div>
        </MaskedElement>
      </Modal.Content>
      <Modal.Footer>
        <div className='flex flex-col items-center gap-3'>
          <Button padding='Fluid' loading={isLoading} disabled={isLoading} onClick={onAccept} testNameSpace={`${testNameSpace}-accept`}>
            <Text bold>{t('account:edit:address:suggestion:content:accept')}</Text>
          </Button>
          <Button.Link disabled={isLoading} onClick={onEdit} testNameSpace={`${testNameSpace}-edit`}>
            {t('account:edit:address:suggestion:content:edit')}
          </Button.Link>
        </div>
      </Modal.Footer>
    </>
  )
}
